export function selectLayer(layerId, map, view) {
  const layer = map.findLayerById(layerId);
  if (layer) {
    map.layers.forEach((l) => {
      const item = l;

      if (item.id === layerId) {
        const { extent } = item.layers.items[0].fullExtent;
        view.goTo(extent);
        item.opacity = 1;
      } else {
        item.opacity = 0.3;
      }
    });
  }
}

export function resetLayerSelection(map) {
  if (map) {
    /* eslint-disable no-param-reassign */
    map.layers.forEach((layer) => {
      layer.opacity = 1;
    });
  }
}
